import { useEffect } from "react";
import { tenantDisplayName } from "../utils/tenantProfile";

export default function TenantFilesModal({
  tenant,
  documents,
  isLoading,
  isWorking,
  selectedFile,
  inputVersion,
  error,
  onFileChange,
  onUpload,
  onOpenDoc,
  onDeleteDoc,
  onClose,
}) {
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape" && !isWorking) onClose();
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [isWorking, onClose]);

  return (
    <div
      className="admin-modal-backdrop"
      role="presentation"
      onMouseDown={(event) => {
        if (event.target === event.currentTarget && !isWorking) onClose();
      }}
    >
      <section className="admin-modal" role="dialog" aria-modal="true" aria-labelledby="tenant-files-title">
        <div className="admin-modal-header">
          <div>
            <p className="admin-page-eyebrow">Tenant documents</p>
            <h2 id="tenant-files-title">{tenantDisplayName(tenant)}</h2>
            <p>{isLoading ? "Loading files..." : `${documents.length} ${documents.length === 1 ? "file" : "files"} uploaded`}</p>
          </div>
          <button className="admin-modal-close" type="button" aria-label="Close tenant files" onClick={onClose} disabled={isWorking}>
            &times;
          </button>
        </div>

        <div className="admin-modal-body">
          <div className="admin-file-upload-panel">
            <label htmlFor={`tenant-file-${tenant.id}`}>Upload a PDF</label>
            <div className="admin-upload-controls">
              <input
                key={inputVersion}
                id={`tenant-file-${tenant.id}`}
                type="file"
                accept="application/pdf"
                onChange={(event) => onFileChange(event.target.files[0] || null)}
                disabled={isWorking || isLoading}
              />
              <button className="admin-button admin-button-primary" type="button" onClick={onUpload} disabled={!selectedFile || isWorking || isLoading}>
                {isWorking ? "Working..." : "Upload PDF"}
              </button>
            </div>
          </div>

          {error && <p className="admin-empty-state admin-error-state" role="alert">{error}</p>}
          {isLoading ? (
            <p className="admin-empty-state">Loading tenant files...</p>
          ) : !documents.length ? (
            <p className="admin-empty-state">No files have been added for this tenant.</p>
          ) : (
            <ul className="admin-modal-file-list">
              {documents.map((doc) => (
                <li key={doc.id}>
                  <div className="admin-modal-file-details">
                    <span className="admin-file-icon" aria-hidden="true">PDF</span>
                    <div>
                      <strong>{doc.name}</strong>
                      <span>Tenant document</span>
                    </div>
                  </div>
                  <div className="admin-row-actions">
                    <button className="admin-button admin-button-secondary" type="button" onClick={() => onOpenDoc(doc.id)} disabled={isWorking}>
                      Open
                    </button>
                    <button
                      className="admin-button admin-button-danger"
                      type="button"
                      disabled={isWorking}
                      onClick={() => {
                        if (window.confirm("Move this document to Trash?")) onDeleteDoc(doc.id);
                      }}
                    >
                      Delete
                    </button>
                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>

        <div className="admin-modal-footer">
          <button className="admin-button admin-button-secondary" type="button" onClick={onClose} disabled={isWorking}>Close</button>
        </div>
      </section>
    </div>
  );
}
